exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background[data-v-6b69b03f]{padding-top:16px}.createBT[data-v-6b69b03f]{margin-left:20px;margin-top:4px}@media screen and (min-width: 800px){#tableSuggestionCategories[data-v-6b69b03f]{width:70%}}\n", ""]);

// exports
